export default function mapeamentoNomeRota(rota, queryString) {
	queryString = queryString || "";

	switch (rota) {
		case "amostras":
			return "Listagem de amostras"
		case "cadastro-amostras":
			return "Cadastro de amostras"
		case "lotes":
			return "Cadastro e gerenciamento de lotes"
		case "dados-lote":
			return queryString.includes("idLote") ? "Editar lote" : "Novo lote";
		default:
			return null
	}
}